import request from "@utils/request";

const SearchApiService = {
    /**
     * 查询
     * @param sApi 查询接口
     * @param pageSize 展示行数
     * @param pageIndex 当前搜索页
     * @param fetchCondition  当时搜索字段值Map

     * @param callback
     * @returns {Function}
     */
    fetch(data={}) {
        return request({
            url:  "/service/mg/allocate/query-logistics",
            method: "POST",
            data
        });
    }
};

export default SearchApiService;
